var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateMenuMagicbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2272 35.8203L51.5952 35.3372L33.0136 40.3914L32.6444 40.8745V58.1182L33.3054 58.5924L51.887 52.3065L52.2272 51.8323V35.8203ZM51.226 36.4752V51.4732L33.6456 57.4204V41.2571L51.226 36.4752Z",
    fill: "#585D66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5775 35.8203L13.2004 35.3349L33.2685 40.3891L33.6468 40.8745V58.1182L33.2969 58.5959H32.9966L12.9285 52.3101L12.5775 51.8323V35.8203ZM13.5787 36.4626V51.4646L32.6456 57.4368V41.2647L13.5787 36.4626Z",
    fill: "#585D66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5784 36L12.5761 35.4835L22.6369 33.1026L22.8674 34.0769L14.8871 35.9655L33 40.5L49.9982 35.9449L42.3414 34.0645L42.5802 33.0922L52.228 35.4616L52.2267 36L32.9311 41.1185L32.7 41.1198L12.5784 36Z",
    fill: "#585D66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6317 18.4994H36.0001V18.4996L22.4993 18.4997V38.5001H23.5005V19.5009L35.9994 19.5008V26.0006H41.9994V38.5H43.0006V26.0045L43.0154 24.9783L37.6317 18.4994ZM41.7312 24.9994L37.162 19.5006H37.0006V24.9994H41.7312Z",
    fill: "#585D66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.103 33.4823L34.7505 36.1483H36.5415L34.0669 32.3544L36.5278 28.663H34.771L33.1714 31.3153H33.0688L31.4692 28.663H29.6235L32.0913 32.4227L29.644 36.1483H31.353L33.0005 33.4823H33.103Z",
    fill: "#585D66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.375 10.3752V8.00018H41.375V10.3752H39V11.3752H41.375V14.0002H42.375V11.3752H45V10.3752H42.375Z",
    fill: "#585D66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.375 18.3752V16.0002H46.375V18.3752H44V19.3752H46.375V22.0002H47.375V19.3752H50V18.3752H47.375Z",
    fill: "#585D66"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.375 22.3752V20.0002H14.375V22.3752H12V23.3752H14.375V26.0002H15.375V23.3752H18V22.3752H15.375Z",
    fill: "#585D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateMenuMagicbox);
export default __webpack_public_path__ + "static/media/create-menu-magicbox.0bb009dcc196f376796308dfe5a85f96.svg";
export { ForwardRef as ReactComponent };